// extracted by mini-css-extract-plugin
module.exports = {"ChooseConsultant":"ChooseConsultant_ChooseConsultant__2lk7-","title":"ChooseConsultant_title__3A6De","text":"ChooseConsultant_text__3-gQx"};